import { Box, CircularProgress, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backbluebtn from "../../../../Utils/Images/backbluebtn.png";
import { GetSingleDiet } from "../../../../APIs/Function/Workout/DietPlans/GetSingleDIet";

const SingleDiet = () => {
  const [singleDiet, setSingleDiet] = useState({});
  const [loading, setLoading] = useState(false);

  const { id } = useParams();

  const handleSingleDiet = async () => {
    try {
      setLoading(true);
      let res = await GetSingleDiet(id);
      setSingleDiet(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleDiet();
  }, []);
  console.log(singleDiet);
  return (
    <>
      {" "}
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/dietplans"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Diet Plan Details
              </Typography>
            </Box>
            <Box></Box>
          </Box>
          {/*contain */}
          <Box
            sx={{
              width: "80%",
              m: "auto",
              boxSizing: "border-box",
              p: 3,
              height: "50vh",
            }}
          >
            <Box
              sx={{
                border: "1px solid #E8E8E8",
                borderRadius: "5px",
                p: 1,
                height: "20%",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "inter",
                  fontSize: "20px",
                  color: "#737373",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                Title :
              </Typography>
              <Typography
                sx={{
                  fontFamily: "inter",
                  fontSize: "24px",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {singleDiet.title}
              </Typography>
            </Box>{" "}
            <Box
              sx={{
                borderRadius: "5px",
                mt: 2,
                height: "75%",
              }}
            >
              <img
                style={{ borderRadius: "5px", objectFit: "cover" }}
                width={"100%"}
                height={"100%"}
                src={
                  singleDiet?.photo
                    ? `https://api-qhealth.equitysofttechnologies.com/upload/images/${singleDiet?.photo}`
                    : ""
                }
                alt=""
              />
            </Box>
            <Box sx={{ overflow: "auto", mt: 2, height: "80%" }}>
              <Grid sx={{ mt: "15px" }} container>
                {/* first column */}
                <Grid item xs={0.5} md={0.5}>
                  {singleDiet.recipe ? ( // Check if singleDiet.recipeexists before mapping
                    singleDiet.recipe.map((e, i) => (
                      <Paper
                        key={i}
                        sx={{
                          borderRadius: "0px",
                          border: "1px solid #EFEFEF",
                          boxShadow: "none",
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                          }}
                        >
                          {i + 1}
                        </Typography>
                      </Paper>
                    ))
                  ) : (
                    <Box sx={{ ml: "400px", mt: "50px" }}>
                      <CircularProgress></CircularProgress>
                    </Box>
                  )}
                </Grid>

                {/* Second Column */}

                <Grid item xs={2} md={2}>
                  {singleDiet.recipe ? (
                    singleDiet.recipe.map((e, i) => (
                      <Paper
                        key={i}
                        sx={{
                          borderRadius: "0px",
                          border: "1px solid #EFEFEF",
                          boxShadow: "none",
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Box sx={{ width: "40px", height: "40px" }}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={`https://api-qhealth.equitysofttechnologies.com/upload/images/${e.recipe_images[0].r_images}`}
                            alt=""
                          />
                        </Box>
                      </Paper>
                    ))
                  ) : (
                    <></>
                  )}
                </Grid>

                {/* Third Column */}

                <Grid item xs={9.5} md={9.5}>
                  {singleDiet.recipe ? (
                    singleDiet.recipe.map((e, i) => (
                      <Paper
                        key={i}
                        sx={{
                          borderRadius: "0px",
                          border: "1px solid #EFEFEF",
                          boxShadow: "none",
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "100%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {e.title}
                        </Typography>
                      </Paper>
                    ))
                  ) : (
                    <></>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SingleDiet;
